import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, tap } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { INavigation, INavigationItem } from "./navigation.types";
import { NAVIGATION_DATA } from "./navigation.data";

@Injectable({
    providedIn: 'root'
})

export class NavigationService {
    private _navigation: ReplaySubject<INavigation> = new ReplaySubject<INavigation>(1);
    _navigationData: INavigation = NAVIGATION_DATA();

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    // get navigation$(): Observable<INavigation> {
    //     return this._navigation.asObservable();
    // }
    get navigation$(): Observable<INavigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    // get(): Observable<INavigation> {
    //     return this._httpClient.get<INavigation>('api/common/navigation').pipe(
    //         tap((navigation) => {
    //             this._navigation.next(navigation);
    //         })
    //     );
    // }

    get() {
        this._navigation.next(this._navigationData);
    }

    getItem(id: string, navigation: INavigationItem[]): INavigationItem | null {
        for (const item of navigation) {
            if (item.id === id) {
                return item;
            }

            if (item.children) {
                const childItem = this.getItem(id, item.children);

                if (childItem) {
                    return childItem;
                }
            }
        }

        return null;
    }
}
